import Fetcher from 'libs/fetcher';

const fetcher = new Fetcher();

export const getOtherConditions = async () => fetcher.get({ path: '/other-conditions' });
